import t from "./ghl-ui.es1245.js";
import i from "./ghl-ui.es1246.js";
var s = Object.prototype, p = s.hasOwnProperty;
function l(r, a, o) {
  var n = r[a];
  (!(p.call(r, a) && i(n, o)) || o === void 0 && !(a in r)) && t(r, a, o);
}
export {
  l as default
};
